import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { EditableGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/editable-grid/editable-grid.component";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { InvStatusKind, SystemKind } from "projects/sepidz-web-framework/src/lib/models/enums";
import { GridFilter, LookupService, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { takeUntil } from "rxjs/operators";
import { InvVoucherHeader } from "../../models/inv-voucher-header.model";

@Component({
  selector: "ngx-inventory-closing-form",
  templateUrl: "./inventory-closing-form.component.html",
  styleUrls: ["./inventory-closing-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InventoryClosingFormComponent extends BaseFormComponent<InvVoucherHeader> {
  erroremessage: string;
  maxCodeLoading: boolean = false;
  currentVoucherKind: any;
  iscCreatingVoucher: boolean = false;
  InvVoucherDetailList: form_control[];
  @ViewChild(EditableGridComponent) grid: EditableGridComponent;
  constructor(
    private lookupservice: LookupService,
    private missetup: MisSetupService,
    protected cd: ChangeDetectorRef,
    protected selectorService: SelectorService
  ) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.iscCreatingVoucher = false;
    this.apiName = "InventoryClosing";
    this.label = "انتقال ابتدای دوره";
    super.ngOnInit();
  }

  setMaxCode() {
    this.model.VoucherKindId = this.formGroup?.get("VoucherKindId")?.value;
    this.model.WarehouseId = this.formGroup?.get("WarehouseId")?.value;
    if (!this.isNewRow || this.maxCodeLoading || !this.model.VoucherKindId) return;

    this.maxCodeLoading = true;
    if (this.accountService.authService.currentFiscalYear) {
      var fiscalYearId = this.accountService.authService.currentFiscalYear.Id;
      this.httpCommonService
        .getMaxCodeWithParameter(this.apiName, this.model.VoucherKindId, fiscalYearId, this.model.WarehouseId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data) => {
            if (!this.model) this.model = <InvVoucherHeader>{};
            if (data && data["VoucherNumber"]) {
              this.model["VoucherNo"] = data["VoucherNumber"] as number;
              if (!this.formGroup) {
                this.setdefault();
                this.setFormGroup(this.model);
              } else {
                this.setValue("VoucherNo", data["VoucherNumber"] as number);
              }
            }
            this.maxCodeLoading = false;
          },
          (error) => (this.maxCodeLoading = false)
        );
    } else {
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) {
          var fiscalYearId = x.Id;
          this.httpCommonService
            .getMaxCodeWithParameter(this.apiName, this.VoucherKind.VoucherKindId, fiscalYearId, this.model.WarehouseId)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data && data["VoucherNumber"]) {
                  this.model["VoucherNo"] = data["VoucherNumber"] as number;
                  if (!this.formGroup) {
                    this.setdefault();
                    this.setFormGroup(this.model);
                  } else {
                    this.setValue("VoucherNo", data["VoucherNumber"] as number);
                  }
                }
                this.maxCodeLoading = false;
              },
              (error) => (this.maxCodeLoading = false)
            );
        }
      });
    }
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.currentVoucherKind = undefined;
    this.InvVoucherDetailList = undefined;
  }
  onChange($event) {
    this.setMaxCode();
    this.isValid();
  }
  setdefault() {
    if (!this.model) {
      this.model = this.model = <InvVoucherHeader>{};
      this.model.VoucherDate = this.accountService.authService.currentFiscalYear.StartDate;
    }
    if (!this.model.BranchId) this.model.BranchId = this.accountService.authService.currentBranchId;
    if (!this.model.FiscalYearId) this.model.FiscalYearId = this.accountService?.authService?.currentFiscalYear?.Id;
    if (!this.model.InvVoucherDetailList) this.model.InvVoucherDetailList = [];
    else this.model.InvVoucherDetailList = this.model.InvVoucherDetailList.sort((a, b) => a.RowNumber - b.RowNumber);

    if (!this.model.SystemKindId) {
      this.lookupservice
        .getLookupbyCode("GNR", "SystemKind", SystemKind.INV)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          this.model.SystemKindId = x.Id;
          this.setValue("SystemKindId", x.Id);
        });
    }
    this.lookupservice
      .getLookupbyCode("INV", "StatusKind", InvStatusKind.Registered)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x) => {
        if (x) {
          this.model.StatusKindId = x.Id;
          this.model.StatusKindCode = x.Code;
          this.model.StatusKindTitle = x.Title;
          this.setValue("StatusKindId", this.model.StatusKindId);
          this.setValue("StatusKindCode", this.model.StatusKindCode);
          this.setValue("StatusKindTitle", this.model.StatusKindTitle);
        }
      });
    super.setdefault();
  }
  setColumnAttribute() {
    this.orignalColumns.forEach((col) => {
      if (col.name === "VoucherNo") {
        col.disabled = true;
        col.userClass = "select-sm";
      } else if (col.name === "WarehouseId" || col.name === "VoucherKindId" || col.name === "VoucherDate") {
        col.required = true;
        col.disabled = !this.isNewRow;
        col.formVisible = true;
        col.userClass = "select-sm";
      } else col.formVisible = false;
    });

    this.columns = this.orignalColumns.filter((f) => f.formVisible);
    this.columns = this.columns.sort((a, b) => a.order - b.order);
    this.setColumnNumber(this.columns);
    this.InvVoucherDetailList = this.getDetailControlModels("InvVoucherDetailList");

    this.columns.forEach((x) => (x.isFloat = null));
  }
  isValid() {
    this.erroremessage = undefined;
    if (!this.model.FiscalYearId) this.model.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
    if (this.model.InvVoucherDetailList.length > 0) this.model.TotalPrice = this.model.InvVoucherDetailList?.getSumWithKey("TotalPrice");
    if (!this.formGroup?.get("VoucherDate")?.value) {
      this.erroremessage = "انتخاب تاریخ الزامی است";
      return false;
    }
    if (
      new Date(this.formGroup.controls["VoucherDate"].value).setHours(0, 0, 0, 0) <
        new Date(this.accountService.authService.currentFiscalYear.StartDate).setHours(0, 0, 0, 0) ||
      new Date(this.formGroup.controls["VoucherDate"].value).setHours(0, 0, 0, 0) >
        new Date(this.accountService.authService.currentFiscalYear.EndDate).setHours(0, 0, 0, 0)
    ) {
      this.erroremessage = "تاریخ سند باید در محدوده سال مالی باشد.";
      return false;
    }
    if (this.iscCreatingVoucher !== true && this.model.InvVoucherDetailList.length <= 0) {
      this.erroremessage = "برای سند هیچ قلمی وارد نشده است.";
      return false;
    }
    return true;
  }
  CreateVoucher() {
    if (this.iscCreatingVoucher === true) return;
    this.iscCreatingVoucher = true;
    if (!this.isValid()) return;
    if (!this.formGroup.get("WarehouseId") || !this.formGroup.get("WarehouseId").value) {
      this.erroremessage = "انبار انتخاب نشده است";
      return;
    }
    if (!this.formGroup.get("VoucherDate") || !this.formGroup.get("VoucherDate").value) {
      this.erroremessage = "تاریخ وارد نشده است";
      return;
    }
    this.model.WarehouseId = this.formGroup.get("WarehouseId").value;
    this.model.VoucherDate = this.formGroup.get("VoucherDate").value;
    this.model.FiscalYearId = this.formGroup.get("FiscalYearId").value;
    this.model.BranchId = this.formGroup.get("BranchId").value;
    this.model.InvVoucherDetailList = [];
    let filter: GridFilter[] = [];
    filter.push({ Filed: "FiscalYearId", Value: this.model.FiscalYearId, Operator: "eq", Type: "F", Skip: 0, Take: 0 });
    filter.push({ Filed: "BranchId", Value: this.model.BranchId, Operator: "eq", Type: "F", Skip: 0, Take: 0 });
    filter.push({ Filed: "WarehouseId", Value: this.model.WarehouseId, Operator: "eq", Type: "F", Skip: 0, Take: 0 });
    filter.push({ Filed: "VoucherDate", Value: this.model.VoucherDate, Operator: "eq", Type: "F", Skip: 0, Take: 0 });
    this.httpCommonService
      .create("InventoryClosing/CreateInventoryClosingVoucher", filter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (results) => {
          this.model.InvVoucherDetailList = results;
          if (this.grid) {
            this.grid.refreshform();
            this.grid.setColumnInfo();
          }
          this.isValid();
        },
        (error) => {
          this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, "خطا در حذف اطلاعات");
        }
      );
  }
  addControl() {
    this.cd.markForCheck();
    this.formGroup.valueChanges.subscribe((x) => {
      this.isValid;
    });
  }
  IsDetailValid(Deleting: boolean): boolean {
    let flag = true;
    if (!this.missetup.getboolean("INV", "NegativeBalance") && this.formGroup.get("WarehouseId") && this.formGroup.get("WarehouseId").value) {
      this.model.WarehouseId = this.formGroup.get("WarehouseId").value;
      this.model.VoucherDate = this.formGroup.get("VoucherDate").value;

      return flag;
    }
  }
  deleteClosingVoucher() {
    this.httpCommonService
      .delete(this.apiName, this.model.Id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (results) => {
          this.sts.showToast("success", "", "اطلاعات با موفیت حذف شد.");
          this.currentrow = undefined;
          this.model = undefined;
          this.ngOnInit();
        },
        (error) => {
          this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, "خطا در حذف اطلاعات");
        }
      );
  }
  deleteVoucher() {
    if (this.model.IsCalculated) {
      this.erroremessage = "این سند به علت قیمت گذاری قابل حذف نمی باشد";
      return;
    }

    this.sts.showDialog(`آیا از حذف ُند اطمینان دارید؟`, "حذف اطلاعات", DialogType.confirm, () => this.deleteClosingVoucher());
  }
}
